import React from 'react';

import { Table, Alert, Button } from 'kepler';

class RecentDonationsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: this.props.transactions ? this.props.transactions : [],
      pageNo: this.props.pageNo,
      invoiceItemDataList: this.props.invoiceItemDataList
        ? this.props.invoiceItemDataList
        : [],
      rowInx: ''
    };
  }
  componentWillReceiveProps(nextProps) {
    let oldData = this.state.transactions, // Array of data
      newData = nextProps.transactions,
      pageNo = nextProps.pageNo,
      invoiceItemDataList = nextProps.invoiceItemDataList,
      rowInx = nextProps.rowInx;
    this.setState({
      invoiceItemDataList: invoiceItemDataList,
      rowInx: rowInx
    });
    if (parseInt(pageNo) > 1) {
      let combinedData = oldData.concat(newData);
      this.setState({
        transactions: combinedData
      });
    } else if (nextProps.transactions) {
      this.setState({
        transactions: nextProps.transactions
      });
    }
  }
  render() {
    let appendInvoiceItemInxObj = this.state.transactions[this.state.rowInx] || {};
    appendInvoiceItemInxObj['invoiceItemDataList'] = this.state.invoiceItemDataList;
    this.state.transactions.invoiceItemDataList = this.state.transactions.invoiceItemDataList || [];

    let renderRecentDonationsTable = this.state.transactions.map(
      (result, index) => {
        result.invoiceItemDataList = result.invoiceItemDataList || [];
        return (
          <tbody key={index}>
            <tr
              className={result.invoice_id ? 'invoiceAvailable' : 'activityRow'}
            >
              <td>{result.date + ' ' + result.month + ' ' + result.year}</td>
              <td>{result.donor_name}</td>
              <td>{result.donor_email_address}</td>
              <td>
                {result.product_description}{' '}
                <i className="icon icon-arrow-down-small" />
              </td>
              <td>
                {(() => {
                  let transactionType = result.type.toString();
                  if (
                    (transactionType && transactionType == 'U') ||
                    !transactionType
                  ) {
                    return <span className="pos" />;
                  } else {
                    return <span className="neg" />;
                  }
                })()}
                {result.payout_amount}
                {result.receiver_account_number ? (
                  <span className="hide accountNo">
                    {result.receiver_account_number}
                  </span>
                ) : (
                  ''
                )}
                {result.invoice_id ? (
                  <span className="hide invoiceId">{result.invoice_id}</span>
                ) : (
                  ''
                )}
              </td>
            </tr>
            <tr className="transSubDetails">
              <td colSpan="3">
                {result.encrypted_transaction_id ? (
                  <span>
                    <strong>Receiver Transaction ID:</strong>{' '}
                    {result.encrypted_transaction_id}
                  </span>
                ) : (
                  ''
                )}
                {result.campaign_title ? (
                  <span>
                    <strong>Campaign Title:</strong> {result.campaign_title}
                  </span>
                ) : (
                  ''
                )}
                {result.item_id ? (
                  <span>
                    <strong>eBay Listing ID:</strong> {result.item_id}
                  </span>
                ) : (
                  ''
                )}
              </td>
              <td colSpan="3">
                {result.invoiceItemDataList.map((r1, inx) => {
                  return <span key={inx}>Item ID: {r1.itemID}</span>;
                })}
              </td>
            </tr>
          </tbody>
        );
      }
    );

    return (
      <div id="activityResult">
        <Table id="recentDonationsTable">
          <colgroup>
            <col width="12%" />
            <col width="20%" />
            <col width="23%" />
            <col width="30%" />
            <col width="15%" />
          </colgroup>
          <thead>
            <tr>
              <th id="date">Date</th>
              <th>Donor Name</th>
              <th>Email</th>
              <th>Program</th>
              <th id="amount">Amount</th>
            </tr>
          </thead>
          {renderRecentDonationsTable}
        </Table>
      </div>
    );
  }
}
export default RecentDonationsTable;



// WEBPACK FOOTER //
// ./partner/components/recentDonationsTable.js